/**
 * 环境判断
 */

import {
  each,
  getWindow
} from '../util';
let theWindow = getWindow();

export const UA = theWindow.navigator.userAgent.toLowerCase();

// 客户端
const regs = {
  'android': /android/i,
  'ios': /iphone/i,

  'weixin': /micromessenger/i,
  'mqq': /QQ\//i,
  'alipay': /aliapp/i,
  'ding': /dingtalk/i,
  'passenger': /didi.passenger/i,
  'lite': /didi.lite/i,
  'sdk': /didi.sdk/i,
  'driverAndroid': /didigsui/i,
  'driverIOS': /ddudriver/i,
  'chrome': /chrome\//i,
  'fusion': /fusionkit/i,
  'guarana': /guarana/i

};

// 版本号
const versionRegs = {
  'passenger': /didi.passenger.*?\/([\d\.]+)/i,
  'lite': /didi.lite\/(.+)$/i,
  'driverAndroid': /didigsui.*_(.+)_\d+_*/i,
  'driverIOS': /ddudriver.*\d_(\d+\.\d+\.\d+)_*/i,
  'android': /android ([\d\.]+)/i,
  'ios': /iphone os ([\d_]+)/i,
  'fusion': /fusionkit\/([\d\.]+)/i
};

const UNKNOWN = 'others';

export let app = {};

export function initApp(DDBridge) {
  let ret = {};
  let version = {};

  each(regs, function(value, key) {
    ret[key] = value.test(UA);
  });
  if (ret.lite) {
    ret.lite = true;
  }
  if (ret.driverAndroid || ret.driverIOS) {
    ret.driver = true;
  };

  each(versionRegs, function(value, key) {
    if (ret[key]) {
      let match = value.exec(UA);

      let res = 'unkown';
      if (match) {
        res = match[1];
      } else {

      }
      version[key] = res;
    }
  });
  version.passenger = version.passenger || version.lite;
  version.driver = version.driverAndroid || version.driverIOS;

  DDBridge.ua = ret;
  DDBridge.app = app = {
    env: ret.lite ? 'lite' : (ret.passenger ? 'passenger' : ret.driver ? 'driver' : UNKNOWN),
    version: version.passenger || version.driver,
    system: ret.ios ? 'ios' : ret.android ? 'android' : UNKNOWN,
    sysVersion: version.ios || version.android,
    fusionKit: ret.fusion,
    guarana: ret.guarana
  };
};

export function isIos() {
  var ua = navigator.userAgent;
  return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

export function isAndroid() {
  var ua = navigator.userAgent;
  return ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
}

export function isFusionKit() {
  return app.fusionKit;
};

export function inApp() {
  var ua = navigator.userAgent;
  return /didi\.passenger/i.test(ua);
};

export function compareAppVersion(...args) {
  switch (args.length) {
    case 2:
      return compare(app.version, args[0], args[1]);
    case 3:
      return compare.apply(null, args);
  }
};

export function compareSysVersion(...args) {
  switch (args.length) {
    case 2:
      return compare(app.sysVersion, args[0], args[1]);
    case 3:
      return compare.apply(null, args);
  }
};

export function compare(v1, symbol, v2) {
  v1 = parse(v1);
  v2 = parse(v2);
  if (symbol.indexOf('=') !== -1 && v1 === v2) {
    return true;
  }
  if (symbol.indexOf('>') !== -1 && v1 > v2) {
    return true;
  }
  if (symbol.indexOf('<') !== -1 && v1 < v2) {
    return true;
  }
  return false;
};

function parse(version = '') {
  version = version.split('.');
  version.length = 4;

  let ret = [];
  each(version, function(n) {
    n = n * 1;
    if (n) {
      ret.push(n >= 10 ? n : '0' + n);
    } else {
      ret.push('00');
    }
  });
  return parseInt(ret.join(''), 10);
}



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/global-api/app.js